import { render, staticRenderFns } from "./RequestEndorsementTable.vue?vue&type=template&id=b9c75bec"
import script from "./RequestEndorsementTable.vue?vue&type=script&lang=js"
export * from "./RequestEndorsementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports